(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bernarda-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bernarda-product')) {
    customElements.define('bernarda-product', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variant-data]')?.textContent || '[]');
        this.thumbs = [...this.querySelectorAll('[data-media-target]')];
        this.media = [...this.querySelectorAll('[data-media-id]')];
        this.radios = [...this.querySelectorAll('.bernarda-product__option input[type="radio"]')];
        this.quantity = this.querySelector('input[name="quantity"]');
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaTarget)));
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.stepMedia(-1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.stepMedia(1));
        this.radios.forEach((radio) => radio.addEventListener('change', () => this.updateVariant()));
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
      }
      showMedia(id) {
        this.media.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === String(id)));
        this.thumbs.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaTarget === String(id)));
      }
      stepMedia(direction) {
        if (!this.media.length) return;
        const current = this.media.findIndex((item) => item.classList.contains('is-active'));
        const next = (current + direction + this.media.length) % this.media.length;
        this.showMedia(this.media[next].dataset.mediaId);
      }
      changeQuantity(delta) {
        if (!this.quantity) return;
        this.quantity.value = Math.max(1, Number(this.quantity.value || 1) + delta);
      }
      updateVariant() {
        const selected = [...this.querySelectorAll('[data-option-position]')].map((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          const label = fieldset.querySelector('[data-selected-option]');
          if (label && checked) label.textContent = '— ' + checked.value;
          return checked?.value;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        this.querySelector('[data-variant-id]').value = variant.id;
        this.querySelector('[data-product-price]').textContent = variant.price;
        const compare = this.querySelector('[data-product-compare]');
        compare.textContent = variant.compareAtPrice || '';
        compare.hidden = !variant.compareAtPrice;
        const availability = this.querySelector('[data-availability]');
        const submit = this.querySelector('[data-add-to-cart]');
        availability.textContent = variant.available ? 'IN STOCK' : 'OUT OF STOCK';
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'ADD TO BAG' : 'OUT OF STOCK';
        if (variant.featuredMediaId) this.showMedia(variant.featuredMediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
